// extracted by mini-css-extract-plugin
export default {"clear_item":"Cart_clear_item__gxuEd","logo":"Cart_logo__l-8pn","loader":"Cart_loader__PE2IM","privacy":"Cart_privacy__jATBo","cart_topic":"Cart_cart_topic__NEOvC"};